// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"MainNavigationDropdown_dropdown__GfLqk","arrow":"MainNavigationDropdown_arrow__YHbSv","content":"MainNavigationDropdown_content__fz10c"};